import 'emoji-picker-element';
import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'; // <-- Import the router

// Import Material Design Icons CSS from CDN
const mdiLink = document.createElement('link');
mdiLink.rel = 'stylesheet';
mdiLink.href = 'https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css';
document.head.appendChild(mdiLink);

const app = createApp(App);

app.config.compilerOptions.isCustomElement = tag => tag === 'emoji-picker';
app.use(router); // <-- Use the router

app.mount('#app')
